import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  consumePasswordlessCode,
  clearPasswordlessLoginAttemptInfo,
} from "supertokens-web-js/recipe/thirdpartypasswordless";
import { toast } from "react-toastify";
import {
  DECCAN_MOBILE_TAB,
  DECCAN_URL,
  PRAJAVANI_EMAIL_TAB,
  PRAJAVANI_MOBILE_TAB,
  REDIRECT_URL,
} from "../contant";
import LoaderComponent from "./LoaderComponent";

export default function MagicLinkConsumableComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get(REDIRECT_URL);
  const emailFromParam = queryParams.get("email");
  const phoneFromParam = queryParams.get("phoneNumber");
  localStorage.setItem("callbackUrl", callbackUrl);
  React.useEffect(() => {
    const tabDetail = emailFromParam
      ? callbackUrl?.toLowerCase()?.includes(DECCAN_URL)
        ? "Email"
        : PRAJAVANI_EMAIL_TAB
      : callbackUrl?.toLowerCase()?.includes(DECCAN_URL)
      ? DECCAN_MOBILE_TAB
      : PRAJAVANI_MOBILE_TAB;
    localStorage.setItem("tab_detail", tabDetail);
    const handleMagicLinkClicked = async () => {
      try {
        let response = await consumePasswordlessCode();
        if (response.status === "OK") {
          await clearPasswordlessLoginAttemptInfo();
          localStorage.setItem(
            "access-token",
            response.fetchResponse.headers.get("st-access-token")
          );
          localStorage.setItem(
            "refresh-token",
            response.fetchResponse.headers.get("st-refresh-token")
          );
          localStorage.setItem(
            "user_login_detail",
            JSON.stringify({
              email: emailFromParam || "",
              phone: phoneFromParam || "",
            })
          );
          if (
            response.createdNewRecipeUser &&
            response.user.loginMethods.length === 1
          ) {
            navigate("/auth/authenticate");
          } else {
            // navigate("/auth/profile")
            window.location.assign(
              `${callbackUrl}?access_token=${response.fetchResponse.headers.get(
                "st-access-token"
              )}&refresh_token=${response.fetchResponse.headers.get(
                "st-refresh-token"
              )}`
            );
          }
        } else {
          // this can happen if the magic link has expired or is invalid
          // or if it was denied due to security reasons in case of automatic account linking

          // we clear the login attempt info that was added when the createCode function
          // was called - so that if the user does a page reload, they will now see the
          // enter email / phone UI again.
          await clearPasswordlessLoginAttemptInfo();
          navigate(`/auth?${REDIRECT_URL}=${callbackUrl}`);
        }
      } catch (err) {
        if (err.isSuperTokensGeneralError === true) {
          // this may be a custom error message sent from the API by you.
          toast.error(err.message);
        } else {
          console.log("Error", err);
        }
      }
    };
    handleMagicLinkClicked();
    return () => {
      // Additional cleanup logic if needed
    };
  }, [navigate]);

  return <LoaderComponent label={"Signing in..."} />;
}
